// Generated by pnpm icons:generate. Edit native source assets and semantic roles, not this file.
import { createCoreLineIcon } from '../CoreLineIcon';
export const MobileIcon = /*#__PURE__*/ createCoreLineIcon(
  'mobile',
  '0 0 14 14',
  '<g><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M10.5 0.5h-7c-0.55228 0 -1 0.447715 -1 1v11c0 0.5523 0.44772 1 1 1h7c0.5523 0 1 -0.4477 1 -1v-11c0 -0.552285 -0.4477 -1 -1 -1Z" stroke-width="1"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M6.5 11h1" stroke-width="1"></path></g>',
);
